import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { PageNotFoundComponent } from './page-not-found.component';
@NgModule({
  imports: [CommonModule, PipesModule, CSButtonComponent],
  declarations: [PageNotFoundComponent],
  exports: [PageNotFoundComponent],
})
export class PageNotFoundModule {}
